import { systemConfig } from '@/config/systemConfig';
import store from '@/store/store';
import {
  DraftSummary,
  LocationEvidenceSummary,
  summarizeDraft,
  summarizeLocationEvidence,
} from '@/utils/factoryVerificationSummary.util';
import { logDebug, logError, logWarning } from '@/utils/logger';

export type { DraftSummary, LocationEvidenceSummary };
export { summarizeDraft, summarizeLocationEvidence };

const LOG_PREFIX = '[factoryVerification]';

function getLogContext(): {
  apiUrl: string;
  token: string;
  user: ReturnType<typeof store.getState>['auth']['user'];
} {
  const state = store.getState();
  return {
    apiUrl: systemConfig.apiUrl,
    token: state.auth.token || '',
    user: state.auth.user,
  };
}

export function logFactoryVerificationDebug(
  step: string,
  data: Record<string, unknown> = {}
): void {
  const ctx = getLogContext();
  logDebug(ctx.apiUrl, ctx.token, ctx.user, `${LOG_PREFIX} ${step}`, {
    ...data,
    step,
    version: systemConfig.version,
  });
}

export function logFactoryVerificationError(
  step: string,
  data: Record<string, unknown> = {}
): void {
  const ctx = getLogContext();
  logError(ctx.apiUrl, ctx.token, ctx.user, `${LOG_PREFIX} ${step}`, {
    ...data,
    step,
    version: systemConfig.version,
  });
}

export function logFactoryVerificationWarning(
  step: string,
  data: Record<string, unknown> = {}
): void {
  const ctx = getLogContext();
  logWarning(ctx.apiUrl, ctx.token, ctx.user, `${LOG_PREFIX} ${step}`, {
    ...data,
    step,
    version: systemConfig.version,
  });
}

export type FactoryVerificationStartFlowTrigger =
  | 'autoRedirect'
  | 'startButton'
  | 'pathResolution'
  | 'gpsResolved';

export type FactoryVerificationStartFlowAction =
  | 'stayOnStart'
  | 'navigateVerification'
  | 'startDirect'
  | 'autoSkipReuse'
  | 'skipNotApplicable';

/**
 * Logs tolerance-gated start-flow decisions to the server for diagnostics.
 */
export function logFactoryVerificationStartFlowDecision(
  trigger: FactoryVerificationStartFlowTrigger,
  data: Record<string, unknown> = {}
): void {
  logFactoryVerificationDebug('startFlow.decision', {
    trigger,
    ...data,
  });
}
